import { eventsApiSlice } from '../../../../../store/eventApiSlice';

export const extendedApiSlice = eventsApiSlice
  .enhanceEndpoints({ addTagTypes: ['EventAdminUser', 'compliance-details'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getComplianceDetails: builder.query({
        query: () => ({
          url: 'compliance/lead-details',
          method: 'get',
        }),
        providesTags: ['compliance-details'],
      }),

      getComplianceTypes: builder.query({
        query: () => ({
          url: 'compliance/types',
        }),
        providesTags: ['compliance-types'],
      }),
      getComplianceEventTypes: builder.query({
        query: () => ({
          url: 'event-admin/event-types',
        }),
        providesTags: ['compliance-events'],
      }),
      getComplianceQualification: builder.query({
        query: () => ({
          url: 'compliance/qualification-schemes',
        }),
        providesTags: ['compliance-qualification'],
      }),
      postComplianceDetails: builder.mutation({
        query: (data) => ({
          url: 'compliance/lead-details',
          method: 'post',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'compliance-details' }],
      }),
      updateComplianceDetails: builder.mutation({
        query: ({ data, id }) => ({
          url: `compliance/organiser-details?id=${id}`,
          method: 'put',
          data,
        }),
        invalidatesTags: (result, error) => [{ type: 'compliance-details' }],
      }),
      logout: builder.mutation({
        query: (request) => ({
          url: 'auth/logout',
          method: 'POST',
          data: request,
        }),
        invalidatesTags: ['EventAdminUser', 'RDO::User'],
      }),
    }),
  });

export const {
  useLogoutMutation,
  useGetComplianceDetailsQuery,
  useGetComplianceQualificationQuery,
  useGetComplianceTypesQuery,
  usePostComplianceDetailsMutation,
  useUpdateComplianceDetailsMutation,
  useGetComplianceEventTypesQuery,
} = extendedApiSlice;
